import { JSEvalContext } from "./types";

export function evalText(jsContext: JSEvalContext, text: string): string | null {
	const exeMode = jsContext.exeMode;
	try {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const dashboard = jsContext.dashboard;
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { context, params, updateContext } = jsContext.pageContext;
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const row = jsContext.row;
		if (text) return text.match("^{.*}$") ? eval(text.replace("{", "").slice(0, -1)) : text;
	} catch (error) {
		const e = error as Error;
		jsContext.logError(e.name + ": " + e.message);
		if (exeMode?.logError) exeMode.logError(`Text: ${text}\n${e.name} : ${e.message} \n ${e.stack}`);
		return null;
	}
	return null;
}

export function evalJs(jsContext: JSEvalContext, script: string): unknown | null {
	const exeMode = jsContext.exeMode;
	try {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const dashboard = jsContext.dashboard;
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { context, params, updateContext } = jsContext.pageContext;
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const row = jsContext.row;
		return eval(script);
	} catch (error) {
		const e = error as Error;
		jsContext.logError(e.name + ": " + e.message);
		if (exeMode?.logError) exeMode.logError(`Script: ${script}\n${e.name} : ${e.message} \n ${e.stack}`);
		return null;
	}
	return null;
}

export function objectToString(obj: unknown, indent = 0) {
	const spacing = "\t".repeat(indent);
	if (typeof obj !== "object" || obj === null) {
		if (typeof obj === "string") {
			return `"${obj}"`;
		}
		return String(obj);
	}
	let result = spacing + "{\n";
	const keys = Object.keys(obj);
	for (const key of keys) {
		const value = (obj as { [key: string]: unknown })[key];
		const keyString = /^[a-zA-Z_]\w*$/.test(key) ? key : `"${key}"`;
		const valueType = typeof value;
		result += `${spacing}  ${keyString}: `;
		if (valueType === "object" && value !== null) {
			result += objectToString(value, indent + 1);
		} else if (valueType === "string") {
			result += `"${value}"`;
		} else {
			result += `${value}`;
		}
		result += ",\n";
	}
	result = result.slice(0, -2) + `\n${spacing}}`;
	return result;
}
